import type {
  TipoTelefoneTemplate,
  TipoTelefoneTemplateOption,
} from '../types/whatsappTemplateNode';

export const tiposTelefoneTemplate = [
  { value: 'NEGOCIACAO', label: 'Negociação' },
  { value: 'ARBITRAGEM', label: 'Arbitral' },
] satisfies TipoTelefoneTemplateOption[];

export function isTipoTelefoneTemplate(value: unknown): value is TipoTelefoneTemplate {
  return value === 'NEGOCIACAO' || value === 'ARBITRAGEM';
}
